export default __webpack_public_path__ + "static/media/01-business_preview.c920d515.jpg";